import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'
import { PetRater } from './PetRater'

export default class PetsRaterAnswers extends RaterAnswers {
  pets: PetRater[]

  constructor(data: any = {}) {
    super(data)

    this.pets = data.pets?.map((p: any) => new PetRater(p)) ?? [new PetRater()]
  }
}
